module.exports = __webpack_public_path__ + "img/55.a65ed480.webp";